import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authenticated, signoutAction } from './ducks/auth';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { scrollToElement } from '../../../lib/userFunctions';
import { useMutation } from '@tanstack/react-query';
// import { apiAuth } from './apiAuth';
import { createFetchErrorMessage } from 'utils/api/ApiClient';
import Api, { errorToast } from 'utils/api/Api';
import { toast } from 'react-toastify';

export const Signin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { school } = useParams();

    const [userid, setUserid] = useState('');
    const [password, setPassword] = useState('');

    const authMutate = useMutation({
        mutationFn: (loginRequest) => {
            return Api.post('/api/auth/signin', loginRequest);
        },
        onSuccess: (res) => {
            dispatch(authenticated(res.data));
            if (res?.data?.leaveDate !== null) {
                toast.warning(`탈퇴 신청중입니다. ${res?.data?.leaveDate} 탈퇴 처리됩니다.`);
                navigate(`/${school}/user/leave`);
            } else {
                navigate(`/${school}`);
            }
        },
        onError: errorToast
    });

    useEffect(() => {
        scrollToElement();
        dispatch(signoutAction());
    }, [dispatch]);

    const onSubmit = (event) => {
        if (authMutate.isPending) return;
        const values = { userid, password, school, admin: false };
        authMutate.mutate(values);
        event.preventDefault();
    }

    // console.log(authAct.error);
    return (
        <div className="subpage">
            <div id="contents" className="member login">
                <div className="section">
                    <div className="inner">

                        <div className="login_area">
                            <div className="login_box">
                                <div className="v_align">
                                    <h2>로그인</h2>
                                    <form action="">
                                        <div className="login_input_area">
                                            <input type="text" name="userid" placeholder="아이디를 입력하세요" className="form-control"
                                                onChange={(e) => { setUserid(e.target.value) }} onKeyDown={(event) => { if (event.key === 'Enter') onSubmit(event); }} autoComplete="false" required />
                                            <input type="password" name="password" placeholder="비밀번호를 입력하세요" className="form-control"
                                                onChange={(e) => { setPassword(e.target.value) }} onKeyDown={(event) => { if (event.key === 'Enter') onSubmit(event); }} />
                                            {!authMutate.isPending && <button type="submit" className="btn _yellow" onClick={onSubmit} ><strong>로그인</strong></button>}
                                        </div>
                                    </form>
                                    {authMutate.isError && <div className="error-text">{createFetchErrorMessage(authMutate.error).message}</div>}
                                </div>
                            </div>
                            <Link to={`/${school}/join`} className="btn _blue join_btn"><span>회원가입</span></Link>
                        </div>
                        <div className="guide_box">
                            <ul className="bullet_list">
                                <li>비밀번호 찾기는 사서선생님, 독서담당선생님께 문의하세요.</li>
                                <li>2019년 사용하던 아이디는 비밀번호 변경 후 이용해주세요.</li>
                                <li>올해 학년, 반, 번호로 수정해주세요.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}